module.exports = __webpack_public_path__ + "media/images/page/top/mv2-8b1198b0c4b6f06bd40eaf8fc131f2bb.jpg";